<template>
  <div>

    <!-- Page Header -->
    <div class="page-header">
      <div>
        <h5 class="page-title">Sales Receipt</h5>
        <p class="page-sub">
          <span class="batch-pill">{{ sales?.batch_code }}</span>
        </p>
      </div>
      <div class="page-actions">
        <button type="button" @click="$router.go(-1)" class="btn-outline">
          <font-awesome-icon icon="arrow-left" /> Back
        </button>
        <PrintButtonHeader
          :title="'Invoice-' + sales?.batch_code"
          :urlA4="'/sales-receipt/'"
          :url58mm="'/print58mm-sales-receipt/'"
          :url80mm="'/print80mm-sales-receipt/'"
          :currentUrl="'View Sales Receipt'"
          :data="sales"
          :type="'Sales Receipt'"
          :loading="loading"
        />
      </div>
    </div>

    <!-- Skeleton -->
    <div v-if="loading" class="invoice-skeleton">
      <div class="skeleton skeleton--hero"></div>
      <div class="skeleton-grid mt-3">
        <div class="skeleton skeleton--field" v-for="n in 4" :key="n"></div>
      </div>
      <div class="skeleton skeleton--table mt-3"></div>
      <div class="skeleton skeleton--field mt-3" style="width:40%;margin-left:auto"></div>
    </div>

    <!-- Invoice -->
    <div v-else class="invoice-wrap">
      <Invoice
        :sales_items="sales_items"
        :sales_array="sales_array"
        :sales="sales"
        :loading="loading"
      />
    </div>

  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import { reusableMixin } from '../../../lib/reusableMixin';
import { useStore } from 'vuex';
import Invoice from './component/invoice';
import axios from 'axios';

export default {
  components: { Invoice },
  mixins: [reusableMixin],

  data() {
    return {
      toast:       useToast(),
      sales:       null,
      sales_items: [],
      sales_array: [],
      store:       useStore(),
      loading:     true,
    };
  },

  created() { this.getSale(); },

  methods: {
    getSale() {
      this.loading = true;
      axios.get(`/inventory/sales/${this.$route.params.id}`)
        .then(response => {
          this.loading      = false;
          this.sales        = response.data.data;
          this.sales_items  = response.data.data.sales_item;
          this.sales_array  = this.sales_items.map(s => ({
            product_name:  s?.product?.product_name,
            selling_price: s?.selling_price,
            variant_name:  s?.variant?.variant_name ?? s?.product?.uom?.name,
            quantity:      s?.quantity,
            tax:           parseFloat(s.tax_amount),
            tax_names:     (s?.product?.taxes ?? []).map(t => t.tax_name).filter(Boolean),
            discount:      s?.discount,
            total:         parseFloat(s?.amount_paid),
          }));
        })
        .catch(() => {
          this.loading = false;
          this.toast.error('Something went wrong');
        });
    },
  },
};
</script>

<style scoped>
/* ── Page Header ── */
.page-header  { display:flex; align-items:flex-start; justify-content:space-between; flex-wrap:wrap; gap:12px; margin-bottom:20px; }
.page-title   { font-size:20px; font-weight:700; color:#1a2b45; margin:0 0 6px; }
.page-sub     { margin:0; }
.page-actions { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }

/* ── Batch Pill ── */
.batch-pill { display:inline-block; background:#edf4ff; color:#004AAD; border:1px solid #c5d6f5; border-radius:20px; padding:2px 12px; font-size:13px; font-weight:600; }

/* ── Skeleton ── */
.invoice-skeleton { background:#fff; border:1px solid #e4eaf2; border-radius:12px; padding:28px; }
.skeleton-grid    { display:grid; grid-template-columns:repeat(4,1fr); gap:16px; }
.skeleton         { border-radius:8px; background:linear-gradient(90deg,#f0f4f8 25%,#e4eaf2 50%,#f0f4f8 75%); background-size:200% 100%; animation:shimmer 1.4s infinite; }
@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
.skeleton--hero   { height:80px; }
.skeleton--field  { height:52px; }
.skeleton--table  { height:240px; }
.mt-3 { margin-top:12px; }

/* ── Invoice Wrap ── */
.invoice-wrap { background:#fff; border:1px solid #e4eaf2; border-radius:12px; overflow:hidden; box-shadow:0 4px 24px rgba(0,0,0,.06); }

/* ── Buttons ── */
.btn-outline { display:inline-flex; align-items:center; gap:7px; background:#fff; color:#1a2b45; border:1px solid #dde5f0; font-size:13px; font-weight:500; padding:9px 18px; border-radius:8px; cursor:pointer; transition:background .15s; }
.btn-outline:hover { background:#f4f7fb; }

/* ── Responsive ── */
@media(max-width:767px) {
  .page-header,.page-actions { flex-direction:column; align-items:stretch; }
  .btn-outline { width:100%; justify-content:center; }
  .skeleton-grid { grid-template-columns:repeat(2,1fr); }
}
</style>